import reports from "@/app/reports/store/reports";
export default {
  modules: {
    reports,
  },
};
